/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_appsync_graphqlEndpoint": "https://l3jeqejxxjcoxaitas32x2bkt4.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-lnrx7peonvc6vpe4nlkbkui2pm",
    "aws_cloud_logic_custom": [
        {
            "name": "atlas",
            "endpoint": "https://xuijvzra03.execute-api.eu-west-1.amazonaws.com/prod",
            "region": "eu-west-1"
        },
        {
            "name": "atlas2",
            "endpoint": "https://i6icqdjik8.execute-api.eu-west-1.amazonaws.com/prod",
            "region": "eu-west-1"
        },
        {
            "name": "atlas3",
            "endpoint": "https://iqh00ch504.execute-api.eu-west-1.amazonaws.com/prod",
            "region": "eu-west-1"
        },
        {
            "name": "betradar",
            "endpoint": "https://rsncgbkyb9.execute-api.eu-west-1.amazonaws.com/prod",
            "region": "eu-west-1"
        },
        {
            "name": "pgvirtual",
            "endpoint": "https://c53f3k9p42.execute-api.eu-west-1.amazonaws.com/prod",
            "region": "eu-west-1"
        },
        {
            "name": "timelesstech",
            "endpoint": "https://gau5n9uzke.execute-api.eu-west-1.amazonaws.com/prod",
            "region": "eu-west-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-1:69b7dc9a-c700-43ea-88d7-1d41b0069e89",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_tYp621STM",
    "aws_user_pools_web_client_id": "2tr68ifp6ojm62k6ul13dqqrqc",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "eu-west-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "accountmovements-prod",
            "region": "eu-west-1"
        },
        {
            "tableName": "agentcommissions-prod",
            "region": "eu-west-1"
        },
        {
            "tableName": "gamesystem-prod",
            "region": "eu-west-1"
        },
        {
            "tableName": "gametickets-prod",
            "region": "eu-west-1"
        },
        {
            "tableName": "messages-prod",
            "region": "eu-west-1"
        },
        {
            "tableName": "systemsecuritylog-prod",
            "region": "eu-west-1"
        },
        {
            "tableName": "thirdpartygames-prod",
            "region": "eu-west-1"
        }
    ]
};


export default awsmobile;
